import { post, get } from '@/utils/request'
import defaultSetting from '@/setting'
const prefix = process.env.NODE_ENV === 'development' ? '/api' : ''
/**
 * 登录
 */
export const getNavApi = () => {
    return post(`${prefix}/wecruit/suite/navigation/menu/${defaultSetting.suiteKey}`);
}
/**
 * 判断是否登录
 */
export const hasLoginApi = () => {
    return post(`${prefix}/wecruit/isLogin/${defaultSetting.suiteKey}`);
}
/**
 * 退出登录
 */
 export const outLoginApi = () => {
    return post(`${prefix}/wecruit/logOut`);
}
/**
 * 职位列表 - 筛选条件
 */
export const getPositionlistSearchTermApi = (data) => {
    return get(`${prefix}/wecruit/positionInfo/listSearchTerm/${defaultSetting.suiteKey}`, data);
}
/**
 * 职位列表 - 职位
 */
export const getPositionlist = (data) => {
    return get(`${prefix}/wecruit/positionInfo/listPosition/${defaultSetting.suiteKey}`, data);
}
/**
 * 公告
 */
export const getDynamicApi = (data) => {
    return get(`${prefix}/wecruit/suite/dynamic/list/${defaultSetting.suiteKey}`, data);
}
/**
 * 获取职位数据
 */
export const getPositionsNumlApi = (data) => {
    return get(`${prefix}/wecruit/positionInfo/listSearchTerm/linkage/${defaultSetting.suiteKeyMc}`, data);
}